import {useCallback, useEffect, useRef, useState} from 'react';

/**
 * Scrollable container with a bottom fade hinting that more content lies
 * below. The fade is visible only while the container can still be scrolled
 * further down, and disappears at (or near) the bottom.
 */
export default function ScrollFade({className = '', fadeClassName = '', children}) {
  const elRef = useRef(null);
  const [moreBelow, setMoreBelow] = useState(false);

  const update = useCallback(() => {
    const el = elRef.current;
    if (!el) return;
    setMoreBelow(el.scrollHeight - el.scrollTop - el.clientHeight > 4);
  }, []);

  // Re-measure after every render: filtering/expanding content changes the
  // scroll height without firing a scroll event.
  useEffect(update);

  return (
    <div className="relative">
      <div ref={elRef} onScroll={update} className={className}>
        {children}
      </div>
      <div
        aria-hidden="true"
        className={`pointer-events-none absolute inset-x-0 bottom-0 h-10 bg-gradient-to-t from-white dark:from-gray-870 to-transparent transition-opacity duration-200 ${moreBelow ? 'opacity-100' : 'opacity-0'} ${fadeClassName}`}
      />
    </div>
  );
}
